<template>
    <div>
        <div class="d-flex align-items-center mb-2">
            <img src="@/assets/images/icons/error.svg" width="24" alt="error" class="mr-2" />
            <p class="modal-heading mb-0">Connection problem</p>
        </div>
        <p class="mb-2">{{ summaryText }}</p>
        <p class="mb-2">Reference code: <strong>{{ errorCode }}</strong></p>
        <p class="mb-4">If this keeps happening, use <strong>Copy details</strong> below and include them (and the reference code) in your support request so we can diagnose it.</p>

        <div class="d-flex align-items-center mt-45">
            <button @click="copy()" class="btn btn-primary btn-lg lg-shadow mr-3">{{ copied ? 'Copied!' : 'Copy details' }}</button>
            <button @click="$emit('close')" class="btn btn-cancel btn-lg lg-shadow">Close</button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ConnectionDiagnosticsModalComponent',

    data() {
        return {
            copied: false
        }
    },

    computed: {
        ...mapGetters({
            connectionDiagnostics: 'SignalRStore/GetConnectionDiagnostics',
            connectionError: 'SignalRStore/GetConnectionError'
        }),

        errorCode() {
            return this.connectionError ? this.connectionError.code : 'RT-004'
        },

        summaryText() {
            return this.connectionError
                ? this.connectionError.summary
                : 'We couldn\'t establish a live connection to the service, so this test can\'t be set up right now. This is usually caused by a network or firewall restriction.'
        },

        diagnosticsText() {
            const header = [
                `Reference code: ${this.errorCode}`,
                `Time: ${new Date().toISOString()}`,
                `Hub: ${process.env.VUE_APP_AXIOS_DIAGNOSTIC_BASE_URL}/diagnosticsHub`,
                `Page: ${window.location.href}`,
                `Browser: ${navigator.userAgent}`,
                '--- connection log ---'
            ].join('\n')

            const entries = this.connectionDiagnostics || []
            const start = entries.length ? new Date(entries[0].at).getTime() : 0
            const lines = entries.map(entry => {
                const elapsed = new Date(entry.at).getTime() - start
                return `+${String(elapsed).padStart(6, ' ')}ms  [${entry.level}]  ${entry.message}`
            })

            return entries.length ? `${header}\n${lines.join('\n')}` : `${header}\n(no connection attempts were recorded)`
        }
    },

    methods: {
        async copy() {
            try {
                await navigator.clipboard.writeText(this.diagnosticsText)
            } catch {
                const textarea = document.createElement('textarea')
                textarea.value = this.diagnosticsText
                document.body.appendChild(textarea)
                textarea.select()
                document.execCommand('copy')
                document.body.removeChild(textarea)
            }
            this.copied = true
        }
    }
}
</script>
